import { forwardRef, ReactNode } from "react";
import { motion } from "framer-motion";
import { usePrefersReducedMotion } from "@/hooks/usePrefersReducedMotion";
import { tileGridVariants } from "@/shared/motion";

interface SelectorTileGridProps {
  children: ReactNode;
  className: string;
}

/**
 * Applies the common selector-grid entrance behavior. Callers retain their exact class
 * names, child order, and measurement ref; the one thing added on their behalf is the
 * side room the tiles' glow needs, which belongs to the tiles rather than to any one
 * screen (see .selector-tile-grid in App.css).
 */
const SelectorTileGrid = forwardRef<HTMLDivElement, SelectorTileGridProps>(({ children, className }, ref) => {
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <motion.div
      ref={ref}
      className={`selector-tile-grid ${className}`}
      variants={tileGridVariants}
      initial={prefersReducedMotion ? false : "hidden"}
      animate="visible"
    >
      {children}
    </motion.div>
  );
});

SelectorTileGrid.displayName = "SelectorTileGrid";

export default SelectorTileGrid;
